module.exports = __webpack_public_path__ + "img/group-list-avter.456efe0b.png";